import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const publicBlogApi = axios.create({
  baseURL: `${API_URL}/api/v1`,
});

const publicBlogService = {
  /**
   * Get published blogs for frontend
   */
  getBlogs: async (params = {}) => {
    try {
      const response = await publicBlogApi.get('/blogs/public', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error;
    }
  },

  /**
   * Get single blog by slug
   */
  getBlogBySlug: async (slug) => {
    try {
      const response = await publicBlogApi.get(`/blogs/public/${slug}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog:', error);
      throw error;
    }
  },

  /**
   * Track share
   */
  trackShare: async (blogId, platform) => {
    try {
      const response = await publicBlogApi.post(`/blogs/public/${blogId}/share`, { platform });
      return response.data;
    } catch (error) {
      console.error('Error tracking share:', error);
      throw error;
    }
  },

  /**
   * Add comment
   */
  addComment: async (blogId, commentData) => {
    try {
      const response = await publicBlogApi.post(`/blogs/public/${blogId}/comments`, commentData);
      return response.data;
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  },

  /**
   * Like blog
   */
  likeBlog: async (blogId) => {
    try {
      const response = await publicBlogApi.post(`/blogs/public/${blogId}/like`);
      return response.data;
    } catch (error) {
      console.error('Error liking blog:', error);
      throw error;
    }
  },

  /**
   * Get categories
   */
  getCategories: async () => {
    try {
      const response = await publicBlogApi.get('/blogs/public/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  /**
   * Search blogs
   */
  searchBlogs: async (query, params = {}) => {
    try {
      const response = await publicBlogApi.get('/blogs/public/search', {
        params: { ...params, query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching blogs:', error);
      throw error;
    }
  }
};

export default publicBlogService;